// 域名配置
const domain = {
  API: '//api.bilibili.com',
  WWW: '//www.bilibili.com',
  SEARCH: '//s.search.bilibili.com',
  INTERFACE: '//interface.bilibili.com',
  SAPI: '//api.bilibili.co',
  MANGA: '//manga.bilibili.com',
}

export default domain
